module.exports = __webpack_public_path__ + "static/media/boyd.cb45a07e.png";